import type { IconTypes } from "solid-icons";
import { FaSolidHouseLaptop } from "solid-icons/fa";
import { ImOffice } from "solid-icons/im";
import { VsRemoteExplorer } from "solid-icons/vs";
import type { RemotePolicy } from "../create/constants";

export const REMOTE_ICONS: Record<RemotePolicy, IconTypes> = {
  remote: FaSolidHouseLaptop,
  onsite: ImOffice,
  hybrid: VsRemoteExplorer,
};
